import React, { FunctionComponent } from 'react';
import {
  Switch,
  Route,
  withRouter,
  Redirect,
  RouteComponentProps,
} from 'react-router-dom';
import withStyles from 'react-jss';
import { compose } from 'recompose';
import { Image, Grid } from 'semantic-ui-react';
import { flip, includes, pathOr } from 'ramda';
import { Location } from 'history';

import { ClassProp } from 'helpers/types';
import logo from 'assets/icons/nav-logo-purple.svg';

import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import NewPassword from './components/NewPassword';
import ResetPassword from './components/ResetPassword';
import Logout from './components/Logout';

import styles from './UserMgmt.styles';

export type Values = {
  email: string;
  password: string;
};

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
  location: Location;
};

const renderRedirect = (props: RouteComponentProps) => {
  const pathName = pathOr('', ['location', 'pathname'], props);
  const search = pathOr('', ['location', 'search'], props);

  return (
    <Redirect
      to={{
        pathname: `/login`,
        state: { referrer: `${pathName}${search}` },
      }}
    />
  );
};
const loginPaths = [
  '/login',
  '/forgot-password',
  '/new-password',
  '/reset-password',
  'logout',
];
const isPathLogin: any = flip(includes)(loginPaths);

const UserMgmt: FunctionComponent<Props> = ({ classes, location }) => {
  const referrer = pathOr('', ['state', 'referrer'], location);

  if (location.pathname === '/login' && referrer !== '') {
    sessionStorage.setItem('referrer', referrer);
  }

  return (
    <>
      {!isPathLogin(location.pathname) && (
        <Route exact path={location.pathname} render={renderRedirect} />
      )}
      <Grid className={classes.grid}>
        <Grid.Column className={classes.column}>
          <Image className={classes.logo} src={logo} wrapped />
          <Switch location={location}>
            <Route exact path="/login" component={Login} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/new-password" component={NewPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route exact path="/logout" component={Logout} />
          </Switch>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default compose<Props, any>(withRouter, withStyles(styles))(UserMgmt);
